'use client'

import Image from 'next/image'
import Link from 'next/link'
import { Badge } from '@nextui-org/react'
import { useRouter } from 'next/navigation'

import { useAppDispatch } from '@/hooks'
import { settingsActions } from '@/redux/reducers/settings/setting.reducer'
import ICONS from '@/assets/icons'
import { useGetNotificationQuery } from '@/redux/api/notification'
import { ParamsFilterNoti } from '@/redux/api/notification/notification.type'
import { cn } from '@/utils/cn'

import styles from './styles.module.css'

const Header = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const params = {
    page: 0,
    limit: 1,
    sort: 'DESC',
    type: undefined,
    isSeen: false,
  } as ParamsFilterNoti
  const { data } = useGetNotificationQuery(params)

  return (
    <header className={styles.headerContainer}>
      <div className={cn(styles.groupHeader, 'flex justify-between items-center', {})}>
        <div>
          <Link href="/feed">
            <div>
              <Image src="/ss-logo-white.svg" width={92} height={23} alt="SightSea" />
            </div>
          </Link>
        </div>

        <div className="flex items-center ">
          {/* <div
            onClick={() => {
              setIsSearch(true)
            }}
            className="p-2"
          >
            <Image src={ICONS.icSearchWhite} className="object-contain cursor-pointer" width={24} height={24} alt="" />
          </div> */}

          <div
            className="px-4"
            onClick={() => {
              router.push('/notifications')
            }}
          >
            <Badge
              color="danger"
              content={
                Number(data?.meta?.totalAllPageItemCount) >= 100
                  ? '99+'
                  : Number(data?.meta?.totalAllPageItemCount) || null
              }
              isInvisible={!Number(data?.meta?.totalAllPageItemCount)}
              shape="circle"
            >
              <Image src={ICONS.notification} className="object-contain cursor-pointer" width={24} height={24} alt="" />
            </Badge>
          </div>
          <Image
            className="cursor-pointer"
            width={24}
            height={24}
            alt=""
            onClick={() => dispatch(settingsActions.setMenu(true))}
            src={ICONS.menuBar}
          />
        </div>

        {/*
        <div className="col-span-7 flex justify-between gap-1.5 flex-1">
          <div className="relative flex-1">
            <SearchComponent
              debounceSecond={1}
              handleSearch={(value) => {
                if (value) {
                  replace(`/explore?search=${value?.trim()}`)
                }
              }}
            />
            <div
              onClick={() => {
                setIsSearch(false)
              }}
              className="absolute top-1/2 -translate-y-1/2 right-4"
            >
              <Image src={ICONS.icCloseWhite} width={20} height={20} alt="Close Search" />
            </div>
          </div>
          <Badge
            className="cursor-pointer"
            onClick={() => {
              router.push('/notifications')
            }}
            color="danger"
            content={Number(data?.meta?.totalAllPageItemCount) || null}
            isInvisible={false}
            shape="circle"
          >
            <Image src={ICONS.notification} className="object-contain cursor-pointer" width={24} height={24} alt="" />
          </Badge>
        </div> */}
      </div>
    </header>
  )
}

export default Header
